export default __webpack_public_path__ + "static/media/extreame_east_grap_chart.68bda073.jpg";